import React from "react"
import heroStyles from "./hero.module.scss"
import {Link} from "gatsby"

const Hero = () => {
  return (
    <div className={heroStyles.hero}>
      <div className={heroStyles.hero__img}>
        <img src={require("../img/Derophotohero.jpg")} alt="hero-img"></img>
      </div>
      <div className={heroStyles.hero__textbox}>
        <h1>DeroFoto</h1>
       
        <img src={require("../img/line_big.svg")} alt="hero-img"></img>
        <h2>fotograf</h2>
        <Link to="/#portfolio" className="btn">Portfolio</Link>
      </div>
    </div>
  )
}
export default Hero
